import {register} from '@shopify/theme-sections';
import $ from 'jquery';
import {renderTemplate} from '../utils/template';

const selectors = {
  list: '[data-products]',
  template: '#upsell-template',
};

const upsellSection = {

  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.template = $(selectors.template).html();
    this.list = $(selectors.list, this.$container);

    if (typeof window.theme === 'undefined') {
      return;
    }

    if (!window.theme.upsellProducts) {
      return;
    }

    this.allProducts = window.theme.upsellProducts;
    this.products = this.getProducts();
    this.build();
  },

  getProducts() {
    return this.allProducts.sort(() => { return 0.5 - Math.random(); }).slice(0, 4);
  },

  build() {
    let list = '';
    $.each(this.products, (index, product) => {
      list += renderTemplate(this.template, product);
    });

    this.list.append(list);
  },
};

register('upsell', upsellSection);
